import { Arrays } from "ext/array";
import * as paper from "paper";
import { addEdgeLips, addMarkers, breakPath, mirrorX, removeLastSegment, setDefaultStyle, smoothCorner } from "../draw";
import { markerSpacing, P, Segments } from "./common";
export class Beaker {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 30, maxX: 120,
                minY: 40, maxY: 160,
                fromAppearance: a => P(a.width, a.height),
                toAppearance: (f, p) => f({ width: p.x, height: p.y }),
                scale: 2.0,
            }
        ];
    }
    render(appearance) {
        let beakerPath = createBasicBeaker(appearance);
        addEdgeLips(beakerPath, { spout: appearance.spout });
        // Clone this path as a liquid mask too.
        let liquidMask = beakerPath.clone();
        // Create a container for the graphic
        let beakerGraphic = new paper.Group([beakerPath]);
        markers(appearance, beakerGraphic);
        setDefaultStyle(beakerGraphic);
        let hitShape = paper.Shape.Rectangle(beakerPath.bounds);
        return {
            graphic: beakerGraphic,
            hitShape: hitShape,
            liquidMask: liquidMask,
            liquidMaskOpening: { start: liquidMask.segments[0].point, end: Arrays.last(liquidMask.segments).point },
            snapping: [
                { type: "neck", top: P(appearance.width / 2, 0), diameter: appearance.width, facing: 0 },
                beakerGraphic.placeable(),
            ]
        };
    }
}
Beaker.properties = {
    label: "Beaker",
    canContainLiquids: true,
    meniscus: true,
    pourable: true,
    flippable: true,
    defaultAppearance: {
        width: 80,
        height: 100,
        spout: false,
    },
    appearanceSpecs: [
        {
            spec: "slider",
            key: "width",
            label: "Width",
            min: 30,
            max: 120,
        },
        {
            spec: "slider",
            key: "height",
            label: "Height",
            min: 40,
            max: 160,
        },
        { spec: "checkbox", key: "spout", label: "Spout" }
    ]
};
export class DisplacementBeaker {
    render(appearance) {
        let beakerPath = createBasicBeaker(appearance);
        let width = appearance.width;
        // let height = appearance.height
        // Add a spout, winding anti clockwise
        beakerPath.insertSegments(5, Segments([[width, 25]], [[width + 15, 28]], [[width + 15, 18]], [[width, 10]]));
        addEdgeLips(beakerPath);
        // Clone this path as a liquid mask too.
        let liquidMask = beakerPath.clone();
        // Create a container for the graphic
        let beakerGraphic = breakPath(beakerPath, 8);
        setDefaultStyle(beakerGraphic);
        markers(appearance, beakerGraphic);
        let hitShape = paper.Shape.Rectangle(beakerPath.bounds);
        return {
            graphic: beakerGraphic,
            hitShape: hitShape,
            liquidMask: liquidMask,
            snapping: [
                beakerGraphic.placeable(),
                { type: "neck", top: P(appearance.width / 2, 0), diameter: appearance.width, facing: 0 },
            ]
        };
    }
}
DisplacementBeaker.properties = {
    label: "Displacement Beaker",
    canContainLiquids: true,
    flippable: true,
    defaultAppearance: Beaker.properties.defaultAppearance,
    appearanceSpecs: Beaker.properties.appearanceSpecs,
};
/** Creates a basic beaker shape, without styles or edge lips. */
function createBasicBeaker(appearance) {
    let width = appearance.width;
    let height = appearance.height;
    let beakerPath = new paper.Path(Segments(
    // beaker side
    [[0, 0]], [[0, height]], 
    // beaker bottom
    [[width / 2, height]]));
    smoothCorner(beakerPath.segments[1]);
    removeLastSegment(beakerPath);
    mirrorX(beakerPath, width / 2);
    return beakerPath;
}
function markers(appearance, group) {
    addMarkers(group, new paper.Point(appearance.width - 5, appearance.height), 8, new paper.Point(0, markerSpacing));
}
